const roundDownToInterval = (number: number, interval = 30): number => {
	if (isNaN(number)) return 0;

	return Math.floor(number / interval) * interval;
};

export default roundDownToInterval;
